module.exports = __webpack_public_path__ + "img/AMD_6764_thumb.6dcd0711.jpg";